export class ColorLegend {
  constructor(legend) {
    this.legend = legend
  }

  onAdd(map) {
    this.map = map

    this.container = document.createElement('div')
    this.container.classList.add('mapboxgl-ctrl')
    this.container.classList.add('mapboxgl-ctrl-group')

    const minimizedButton = document.createElement('button')
    minimizedButton.type = 'button'
    minimizedButton.classList.add('mapboxgl-ctrl-icon')
    minimizedButton.classList.add('mapboxgl-color-legend')
    minimizedButton.addEventListener('click', () => {
      minimizedButton.style.display = 'none'
      this.maximizedContainer.style.display = 'block'
    })

    this.legendContainer = document.createElement('div')
    this.legendContainer.classList.add('legend-content')
    this.legendContainer.style.display = 'block'
    this.legendContainer.innerHTML = this.legend

    this.maximizedContainer = document.createElement('div')
    this.maximizedContainer.appendChild(this.legendContainer)
    this.maximizedContainer.style.display = 'none'

    this.maximizedContainer.addEventListener('click', () => {
      minimizedButton.style.display = 'block'
      this.maximizedContainer.style.display = 'none'
    })

    this.container.appendChild(this.maximizedContainer)
    this.container.appendChild(minimizedButton)

    return this.container
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container)
    this.map = undefined
  }
}
